import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import FusePageCarded from '@fuse/core/FusePageCarded/FusePageCarded';

export const AuraTabRoot = styled(FusePageCarded)(({ theme }) => ({
  '& .FusePageCarded-topBg': {
    display: 'flex',
    background: `linear-gradient(to right, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    color: theme.palette.primary.contrastText,
    backgroundSize: 'cover',
    backgroundColor: theme.palette.primary.dark,
    minHeight: 122,
    height: 122,
  },
  '& .FusePageCarded-header': {
    minHeight: '72px !important',
    height: '72px !important',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      minHeight: 122,
      height: 122,
    },
  },
  '.FusePageCarded-toolbar': {
    height: '50px !important',
    minHeight: '50px !important',
  },
  '.MuiTab-root': {
    minHeight: '50px !important',
  },
}));

const HeaderButton = styled(Button)(({ theme }) => ({
  lineHeight: 1.5,
  borderRadius: '5px',
}));

export const DialogButton = styled(Button)(({ theme }) => ({
  lineHeight: 1.5,
  height: '35px',
  minHeight: '35px',
  maxHeight: '35px',
  borderRadius: '5px',
}));

export default HeaderButton;
